import { DocumentReference } from "firebase/firestore";
import VersaoTermo from "./versaoTermo";

export default class Termo implements ITermo {
  public ref!: DocumentReference<Termo>;
  public titulo!: string;
  public slug!: string;
  public obrigatorio!: boolean;
  public ordem!: number;
  public versaoVigente?: DocumentReference<VersaoTermo>;

  constructor(param: ITermo) {
    Object.assign(this, param);
  }
}

interface ITermo {
  ref: DocumentReference<Termo>;
  titulo: string;
  slug: string;
  obrigatorio: boolean;
  ordem: number;
  versaoVigente?: DocumentReference<VersaoTermo>;
}
